"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _redux = require("redux");

var _dispatchReducers = require("./dispatchReducers");

var createStore = function createStore(props) {
  var _props$initialState = props.initialState,
      initialState = _props$initialState === void 0 ? {} : _props$initialState,
      _props$reducers = props.reducers,
      reducers = _props$reducers === void 0 ? {} : _props$reducers,
      _props$middleware = props.middleware,
      middleware = _props$middleware === void 0 ? [] : _props$middleware,
      _props$enhancers = props.enhancers,
      enhancers = _props$enhancers === void 0 ? [] : _props$enhancers;
  var store = (0, _redux.createStore)((0, _redux.combineReducers)(reducers), initialState, _redux.compose.apply(void 0, [_redux.applyMiddleware.apply(void 0, middleware)].concat(enhancers)));
  (0, _dispatchReducers.resolveDispatch)(store.dispatch);
  return store;
};

var _default = createStore;
exports["default"] = _default;